/* React */
import React from "react";

/* Components */
import SegmentButton from "src/components/shared/buttons/segment-button/SegmentButton";

/* Stylesheet */
import styles from "./BooleanSelect.module.scss";

/* Interfaces */
import {
  Keys,
  BasicProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface BooleanSelectProps {
  options: boolean[];
  value: boolean;
  disabled: boolean;
  handleUpdate: <K extends keyof BasicProps>(
    key: K,
    data?: {
      value: BasicProps[K];
    }
  ) => void;
}

const BooleanSelect: React.FC<BooleanSelectProps> = ({
  options,
  value,
  disabled,
  handleUpdate,
}) => {
  return (
    <div className={styles.boolean_select}>
      {options.map((option: boolean, index: number) => {
        const isSelected = value === option;

        return (
          <SegmentButton
            key={index}
            label={option}
            value={isSelected}
            disabled={disabled}
            onClick={() => handleUpdate(Keys.VALUE, { value: option })}
          />
        );
      })}
    </div>
  );
};

export default BooleanSelect;
